import React from 'react';
import {useEffect, useState} from "react";
import {setLoadingStateDispatch, useLoadingDispatcher} from "../../context/LoadingContext";
import {setSnackbarDispatch, SnackbarActionTypes, useSnackbarDispatcher} from "../../context/SnackBarContext";
import {useAuthState} from "../../context/AuthContext";
import {FileManagerService} from "./FileManagerService";
import {Grid, LinearProgress} from "@mui/material";
import Box from "@mui/material/Box";
import RaikoDefaultDialogPage, {DialogSize} from "../defaultDialogPage/RaikoDefaultDialogPage";
import {css} from "@emotion/css";
import ButtonPrimaryRaiko from "../../raikoComponents/raikoButtons/ButtonPrimaryRaiko";
import RaikoGridOneColumn from "../../raikoComponents/raikoCustomGrids/RaikoGridOneColumn";
import RaikoToggleOutlined from "../../raikoComponents/raikoCustomInput/raikoToggleOutlined/RaikoToggleOutlined";

const FileManagerUploadNewImage = ({openModal, needRefresh, handleClose, fileManagerType}) => {

    const loading = useLoadingDispatcher()
    const snackbar = useSnackbarDispatcher()
    const token = useAuthState().token

    const service = new FileManagerService(loading, snackbar, token)

    useEffect(() => {
        if (!openModal) {
            clearFields()
        }
    }, [openModal])


    const [imageName, setImageName] = useState("لطفا تصویر مورد نظر را انتخاب نمایید !")

    const [hideImageUploadLoading, setHideImageUploadLoading] = useState(true)
    const [progressImage, setProgressImage] = useState(0)
    const [bufferImage, setBufferImage] = useState(5)
    const [imageFile, setImageFile] = useState(null);
    const [image, setImage] = useState("");

    const [publishState, setPublishState] = useState(true);

    function clearFields() {
        setImageName("لطفا تصویر مورد نظر را انتخاب نمایید !")
        setHideImageUploadLoading(true)
        setProgressImage(0)
        setBufferImage(5)
        setImageFile(null)
        setImage("")
    }


    function uploadSliderImage({target: {files}}) {
        if (typeof files[0] !== 'undefined') {
            setImageFile(files[0])
            setImageName(files[0].name)
            setImage(URL.createObjectURL(files[0]))
        }
    }

    function handleUploadNewImage() {
        if (imageFile !== null) {
            loading(setLoadingStateDispatch(true))
            needRefresh(true)
            service.uploadImageToServer(imageFile, publishState, setHideImageUploadLoading, setProgressImage, setBufferImage, fileManagerType)
                .then(response => {
                    clearFields()
                    snackbar(setSnackbarDispatch(SnackbarActionTypes.SHOW_SUCCESS, "تصویر جدید با موفقیت بارگزاری شد."))
                    loading(setLoadingStateDispatch(false))
                }).catch(reason => {
                snackbar(setSnackbarDispatch(SnackbarActionTypes.SHOW_ERROR, "خطا در بارگزاری تصویر جدید!"))
                loading(setLoadingStateDispatch(false))
            })
        } else {
            snackbar(setSnackbarDispatch(SnackbarActionTypes.SHOW_WARNING, "لطفا ابتدا تصویر مورد نظر را انتخاب نمایید !"))
        }
    }

    return (
        <RaikoDefaultDialogPage
            pageTitle={`بارگزاری تصویر جدید در دسته ${fileManagerType.name}`}
            dialogSize={DialogSize.SMALL}
            onClose={handleClose}
            open={openModal}
            selectedValue={""}>
            <section className={css`padding: 0 16px 16px 16px;
              display: flex;
              flex-direction: column;
              height: 100%;
              flex-grow: 1;
            `}>
                <Box className="d-flex flex-column flex-grow-1 w-100 h-100" sm={12}>
                    <RaikoGridOneColumn>
                        <input
                            id="sliderImageFile"
                            type="file"
                            hidden={true}
                            multiple
                            accept="image/png,image/gif,image/jpeg"
                            onChange={uploadSliderImage}
                        />
                        <div className={`uploadImageContent ${
                            css`

                            `
                        }`}
                             onDragOver={event => {
                                 event.stopPropagation();
                                 event.preventDefault();
                                 event.dataTransfer.dropEffect = 'copy';
                             }}

                             onDrop={event => {
                                 event.stopPropagation();
                                 event.preventDefault();
                                 uploadSliderImage({target: {files: event.dataTransfer.files}})
                             }}

                             id="uploadImageContent">
                            <div className="d-flex alignItemsCenter">
                                {image ?
                                    <img
                                        className={css`
                                          object-fit: fill;
                                          max-width: 25%;
                                        `}
                                        alt=""
                                        src={image}
                                    /> :
                                    <div className="ic-picture"/>}
                                <div className="upload-text-content">
                                    <span className="upload-text">آپلود تصویر</span>
                                    <span className="drop-down-text">تصویر را به اینجا بکشید.</span>
                                </div>
                                {/*<span className="fs-1 mt-2 p-2">{imageName}</span>*/}
                            </div>
                            <ButtonPrimaryRaiko
                                label={"انتخاب فایل"}
                                onClick={_ => document.getElementById("sliderImageFile").click()}/>
                        </div>
                        <div className={`${hideImageUploadLoading ? "d-none" : "d-block"}`}>
                            <LinearProgress
                                hidden={hideImageUploadLoading}
                                className='w-100 mt-2'
                                variant="buffer"
                                value={progressImage}
                                valueBuffer={bufferImage}/>
                        </div>

                        {/*<RaikoToggleOutlined
                            labelText={"وضعیت انتشار عمومی"}
                            checked={publishState}
                            setChecked={setPublishState}/>*/}

                        <div className={css`display: flex;
                          justify-content: left;
                          margin-top: 8px;
                        `}>
                            <ButtonPrimaryRaiko label={"تایید"} onClick={handleUploadNewImage}/>
                        </div>
                    </RaikoGridOneColumn>
                </Box>
            </section>
        </RaikoDefaultDialogPage>
    )
};

export default FileManagerUploadNewImage
